<template>
    <z-modal
        v-if="modalData && (modalData?.video?.value || modalData?.image?.link)"
        class="modal-banner"
        id="mainModalBanner"
        @close="(e)=> onModalClose(e)"
    >
        <div>
            <h3 class="modal-banner__title">{{ modalData?.name }}</h3>
            <div class="modal-banner__content">
                <z-video
                    v-if="modalData?.video?.value"
                    ref="video"
                    :muted="false"
                    :src="modalData?.video?.value"
                    :autoplay="false"
                    :poster="modalData.image.link"
                />
                <z-image
                    v-else
                    :src="modalData?.image?.link"
                    alt=""
                />
            </div>
            <z-button
                tag="a"
                kind="bordered"
                size="s"
                class="modal-banner__button"
                :href="modalData.link.value"
            >
                {{ buttonText }}
                <template #right>
                    <z-icon
                        name="arrows/round-arrow-big"
                        width="19"
                        height="19"
                        dir="right"
                    />
                </template>
            </z-button>
        </div>
    </z-modal>
</template>
<script setup>
import cookie from 'cookie_js'
import {onMounted, ref} from 'vue';
import ZModal from '@/components/ZModal'
import ZButton from '@/components/ZButton'
import { useGetter } from '@/composable/useGetter'
import { useEmitter } from '@/composable/useEmmiter'
import { localize } from '@/utils/i18n'

const emitter = useEmitter()
const { app } = useGetter(['app'])

const props = defineProps({
    delay: {
        type: Number,
        default: 3000,
    }
})

const modalData = app.value.components?.banners?.[0]
const isModalBannerShown = ref(false)

const buttonText = localize({
    ru: 'Перейти',
    en: 'Learn more',
    cn: '更多详情'
})

const onModalClose = (data) => {
    if(data.element === 'button'){
        cookie.set({
            isModalBannerShown: true
        }, {
            domain: '.' + location.host,
            path: '/',
            expires: 365
        })
    }
}

const showModalBanner = () => {
    if(!isModalBannerShown.value){
        emitter.emit('open-modal', {id: 'mainModalBanner'})
    }
}

onMounted(() => {
    isModalBannerShown.value = cookie.get('isModalBannerShown')
    setTimeout(() => {
        showModalBanner();
    },props.delay)
    setTimeout(() => {
        emitter.emit('close-modal', {id: 'mainModalBanner'})
    },props.delay + 5000)
})

</script>

<style lang="scss">
.modal-banner{

    &__title{
        max-width: calc(100% - 32px);
        @include margin-level(bottom, M);
        @include typo-level(XL);
    }

    &__button{
        @include margin-level(top, S);
        padding-top: 16px;
        padding-bottom: 16px;

        & .z-button__icon--align-right{
            margin: 0 0 0 8px;
        }
    }

    & .z-modal__container{
        width: 100%;

        @include breakpoint(mobile){
            padding: var(--spacer-m);
        }
    }

    & .modal-html{
        padding: 0;
    }

    & .z-modal__close{
        top: 0;
        right: 0;
        translate: 7px 0;
    }
}
</style>
